// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "cover-28yTy";
export { _1 as "__esModule", _2 as "cover" }
export default { "__esModule": _1, "cover": _2 }
